import DOMPurify from "isomorphic-dompurify";

DOMPurify.setConfig({
  ADD_ATTR: ["target"],
  ALLOW_DATA_ATTR: true,
});

export default DOMPurify;
